<template>
  <div>
    <b-alert show variant="danger" v-if="SHOW_WARNING">Site is Disabled</b-alert>
  <router-view v-if="loaded && !DISABLED"/>

    <div v-if="DISABLED" style="text-align:center">
      <h1>PageWatch</h1>
      <b-alert show variant="danger">We are currently busy making some updates, PageWatch should be available again within 30 minutes, sorry for the inconvenience</b-alert>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import axios from "axios";
import { mapState } from "vuex";
export default {
  name: 'App',
  data() {
    return {
      loaded: false,
      DISABLED: false,
      SHOW_WARNING: false,
      pageTitle: '',
      pageUrl: '',
      metaImage: '',
      screenshots: {},
      authenticatedPage: false,
    };
  },
  apollo: {
    metaImage:{
      query(){ return gql`query {
          metaImage: users_user{
            websites_website{
              url
              websites_crawledpages(limit: 1, where: {ready: {_eq: true}, is_latest: {_eq: true}, level: {_eq: 0}}) {
                url
                title
                websites_devicerenders{
                  device_id
                  screenshots
                }
              }
            }
          }
    }`
      },
      result(data, b){
        try {
          if (data.data.metaImage &&  data.data.metaImage.length > 0 && data.data.metaImage[0].websites_website.websites_crawledpages.length > 0) {
            for (let s of data.data.metaImage[0].websites_website.websites_crawledpages[0].websites_devicerenders) {
              this.screenshots[s.device_id] = s.screenshots;
            }
            let mainImage = this.screenshots['chrome'].main.screenshot.url.replace('https://ik.imagekit.io/pagewatch', '').split('/').join('@@');
            let mobileImage = this.screenshots['galaxy_s6'].main.screenshot.url.replace('https://ik.imagekit.io/pagewatch', '').split('/').join('@@');

            let f = `https://ik.imagekit.io/pagewatch/transparent_Oga4FuFY_.png?tr=w-800,h-400:oi-${mainImage},oit-false,ox-0,oy-0,oh-400:oi-iphone_JWSVxSvaK.png,oit-false,ox-580,oy-25,oh-350:oi-${mobileImage},oit-false,ox-589,oy-52,oh-292`
            this.metaImage = f;
            this.pageTitle = data.data.metaImage[0].websites_website.websites_crawledpages[0].title;
            this.pageUrl = data.data.metaImage[0].websites_website.websites_crawledpages[0].url;
          }
        }
        catch (err){
          console.log(err);
        }
      },
      skip(){
        return !this.authenticatedPage || this.DISABLED;
      },
    },
    $subscribe: {
      crawlState: {
        query() {
          return gql`subscription{
            crawlState:users_user{
                id
                email
                websites_website{
                  id
                  url
                  deleted
                  siteCrawl:websites_crawls(where: {scope:{_eq: "site"}}, order_by: {started_at: desc}, limit: 1){
                    id
                    started_at
                    options
                    errors
                    status
                    spellcheck_completed
                    link_check_completed
                  }
                  pageCrawls:websites_crawls(where: {scope:{_eq: "page"}}, order_by: {started_at: desc}, limit: 10){
                    id
                    started_at
                    options
                    status
                    spellcheck_completed
                    link_check_completed
                  }
                }
            }
          }`
        },
        result(data) {
          let oldStatus = this.scanStatus.completed;
          let website = data.data.crawlState[0].websites_website;

          let siteCrawl = website.siteCrawl[0] || {};
          let status = {
            completed: true,
            statusText: 'completed',
            site: {
              crawlCompleted: siteCrawl.status === 'completed' || siteCrawl.status === 'error',
              status: siteCrawl.status,
              statusText: siteCrawl.status,
              errors: siteCrawl.errors || [],
              linkCheckCompleted: siteCrawl.link_check_completed,
              spellCheckCompleted: siteCrawl.spellcheck_completed,
            },
            pageErrors:[],
            pages: []
          };
          let pagesPending = false;
          for (let pageCrawl of website.pageCrawls){
            if (pageCrawl.status === 'completed' && pageCrawl.link_check_completed && pageCrawl.spellcheck_completed){
              continue
            }
            for (let path of pageCrawl.options.page_paths){

              if (pageCrawl.status === 'pending' || pageCrawl.status === 'in_progress' || !pageCrawl.link_check_completed || !pageCrawl.spellcheck_completed){
                pagesPending = true;
                status.pages.push({
                  path: path,
                  status: pageCrawl.status,
                  crawlCompleted: pageCrawl.status === 'completed' || pageCrawl.status === 'error',
                  linkCheckCompleted: pageCrawl.link_check_completed,
                  spellCheckCompleted: pageCrawl.spellcheck_completed,
                });
              }
              if (pageCrawl.status === 'error'){
                // only include errors if less than hour old
                if (this.$moment().diff(this.$moment(pageCrawl.started_at), 'minutes') < 60){
                  status.pageErrors.push(path)
                }
              }
            }
          }
          status.completed = !pagesPending && status.site.crawlCompleted && status.site.linkCheckCompleted && status.site.spellCheckCompleted;
          if (!status.completed){
            status.statusText = 'In Progress';
          }
          this.$store.commit("setScanStatus", status);

          if (status.completed && !oldStatus) {
            this.$root.$emit('scan_completed');
          }

        },
        skip() {
          return !this.authenticatedPage || this.DISABLED;
        },
      },
      user: {
        query() {
          return gql`subscription{
          user: users_user{
            id
            email
            role
            available_audits
            websites_subscription{
              id
              websites_plan{
                id
                name
                display_name
              }
            }
            websites_website{
              id
              demo
              deleted
              url
              recurring
              recurring_schedule
              uuid
              websites_crawls(limit: 1, order_by: {completed_at: desc}){
               id
               websites_crawl_devices{
                websites_device{
                  id
                  name
                  platform
                  viewport
                  mockup
                }
               }
              }
            }
          }
        }`
        },
        skip() {
          return !this.authenticatedPage || this.DISABLED;
        },
        result(result) {
          if (result.error) {
            this.loaded = true;
            return;
          }
          if (result.data.user[0].websites_website && result.data.user[0].websites_website.id) {

            if (!this.activeSite.id || this.activeSite.id !== result.data.user[0].websites_website.id){
              let devices = [];
              if (result.data.user[0].websites_website.websites_crawls[0]) {
                devices = result.data.user[0].websites_website.websites_crawls[0].websites_crawl_devices.map((v) => {
                  return {
                    id: v.websites_device.id,
                    platform: v.websites_device.platform,
                    title: `${v.websites_device.platform} (${v.websites_device.viewport.width}x${v.websites_device.viewport.height})`,
                    width: v.websites_device.viewport.width,
                    height: v.websites_device.viewport.height,
                    mockup: v.websites_device.mockup,
                    viewport: v.websites_device.viewport,
                  }
                });
                devices.sort((a, b) => {
                  return a.width - b.width
                });
              }
              let recurringSchedule = '';
              if (result.data.user[0].websites_website.recurring && result.data.user[0].websites_website.recurring_schedule){
                recurringSchedule = result.data.user[0].websites_website.recurring_schedule;
              }

              let activeSite = {
                id: result.data.user[0].websites_website.id,
                demo: result.data.user[0].websites_website.demo,
                url: result.data.user[0].websites_website.url,
                uuid: result.data.user[0].websites_website.uuid,
                recurringSchedule: recurringSchedule,
                devices: devices
              };
              this.$store.commit("setActiveSite", activeSite);
            }

            result.data.user[0].plan = 'free';
            if (result.data.user[0].websites_subscription && result.data.user[0].websites_subscription.websites_plan){
              result.data.user[0].plan = result.data.user[0].websites_subscription.websites_plan.name;
            }
            this.$store.commit("setUser", result.data.user[0]);
          }
          else{
            this.$store.commit("setActiveSite", {});
          }
         if (result.data.user[0].role === 'readonly'){ // XXSUBXX
            this.authenticatedPage = false;
         }

          this.loaded = true;

          if (result.data.user[0].websites_website.deleted){
            this.$router.push({ name: "NewPage" });
          }
        },
        error(error) {
          console.log(error)
          // this.$router.push('/login');
          // window.location.reload(false);
        }
      }
    },
  },
  metaInfo(){

    let shortUrl = (this.pageUrl).replace('https://', '').replace('http://', '').replace('www.', '');
    return {
      title: `PageWatch Report: ${shortUrl}`,
      meta: [
        // Twitter Card
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:title', content: `PageWatch Report: ${shortUrl}`},
        {name: 'twitter:description', content: this.pageTitle},
        // image must be an absolute path
        {name: 'twitter:image', content: this.metaImage},
      ]
    }
  },
  watch: {
    'activeSite': function () {
      this.$root.$emit('global_reload');
    }
  },
  methods: {
  },
  computed: {
    ...mapState({ activeSite: "activeSite", scanStatus: "scanStatus" })
  },
  created() {
    if (this.DISABLED){
      if (window.localStorage.getItem(`PAGEWATCH_ENABLE`)){
        this.DISABLED = false;
        this.SHOW_WARNING = true;
      }
    }
    const currentPath = this.$router.history.current.path;
    if (currentPath !== '/login' && currentPath !== '/register' && currentPath !== '/error') {
      this.authenticatedPage = true;
    }
    else{

      this.loaded = true;
    }
    this.$root.$on('websites-reload',  async() => {
      if (this.$apollo.queries.user) {
        await this.$apollo.queries.user.refetch();
      }
      // this.$router.push({ name: "Dashboard" });
    });
  },
};
</script>

<style src="./styles/theme.scss" lang="scss" />
